import { apiClient } from '../api'
import type { Organization, OrgRole } from '@reqtrack/shared'

export interface OrgListItem extends Organization {
  role: OrgRole
  productCount: number
}

export interface OrganizationWithCounts extends Organization {
  memberCount: number
  productCount: number
}

export interface MemberWithUser {
  id: string
  orgId: string
  userId: string
  role: OrgRole
  joinedAt: Date
  user: {
    id: string
    name: string
    email: string
  }
}

export async function getOrgs(): Promise<{ data: OrgListItem[]; total: number }> {
  const res = await apiClient.get<{ data: OrgListItem[]; total: number }>('/orgs')
  return res.data
}

export async function getOrg(orgId: string): Promise<{ data: OrganizationWithCounts }> {
  const res = await apiClient.get<{ data: OrganizationWithCounts }>(`/orgs/${orgId}`)
  return res.data
}

export async function createOrg(data: { name: string; slug?: string }): Promise<{ data: Organization }> {
  const res = await apiClient.post<{ data: Organization }>('/orgs', data)
  return res.data
}

export async function updateOrg(orgId: string, data: { name?: string }): Promise<{ data: Organization }> {
  const res = await apiClient.patch<{ data: Organization }>(`/orgs/${orgId}`, data)
  return res.data
}

export async function getOrgMembers(orgId: string): Promise<{ data: MemberWithUser[]; total: number }> {
  const res = await apiClient.get<{ data: MemberWithUser[]; total: number }>(`/orgs/${orgId}/members`)
  return res.data
}

export async function addOrgMember(
  orgId: string,
  data: { email: string; role: OrgRole }
): Promise<{ data: MemberWithUser }> {
  const res = await apiClient.post<{ data: MemberWithUser }>(`/orgs/${orgId}/members`, data)
  return res.data
}

export async function updateMemberRole(
  orgId: string,
  userId: string,
  data: { role: OrgRole }
): Promise<{ data: MemberWithUser }> {
  const res = await apiClient.patch<{ data: MemberWithUser }>(`/orgs/${orgId}/members/${userId}`, data)
  return res.data
}

export async function removeMember(orgId: string, userId: string): Promise<void> {
  await apiClient.delete(`/orgs/${orgId}/members/${userId}`)
}
